import { FormatDate, formatStringMDYFullMonth, formatStringMYFullMonth } from './DateUtils';
import { StringFormat } from './StringUtils';

import { PortalCreateSubmissionRequestOptions } from '../Models/PortalCreateSubmissionRequestOptions';

import { PortalTextCommon } from '../Models/Api/strongbox.financialportal';

export function GetCollectionRangeSummary(requestSummary: PortalCreateSubmissionRequestOptions, commonText?: PortalTextCommon): string {
    // Can't just do a ! here, month can be 0.  If we don't actually have a mostRecentPeriodDay which is possible for
    // older collections, the value won't be undefined, it'll be null so this if statement will not trigger.

    if ((requestSummary.mostRecentPeriodMonth === undefined) ||
        (requestSummary.mostRecentPeriodYear === undefined) ||
        (requestSummary.mostRecentPeriodDay === undefined)) {
        return '';
    }

    // Originally we didn't track the mostRecentPeriodDay value so for older requests, it can be undefined here.  Fall
    // back to that original handling.

    let d: Date;
    let formatString: string;

    if (requestSummary.mostRecentPeriodDay === null) {
        d = new Date(requestSummary.mostRecentPeriodYear, requestSummary.mostRecentPeriodMonth);
        formatString = formatStringMYFullMonth;
    } else {
        d = new Date(requestSummary.mostRecentPeriodYear, requestSummary.mostRecentPeriodMonth, requestSummary.mostRecentPeriodDay);
        formatString = formatStringMDYFullMonth;
    }

    if (requestSummary.fullFiscalYearsToCollect !== 0) {
        const fullYears = requestSummary.fullFiscalYearsToCollect.toString();

        return requestSummary.fullFiscalYearsToCollect !== 1 ? 
            StringFormat(commonText?.templateFinancialInformationProvidedForFullYears || '{0}{1}', fullYears, FormatDate(d, formatString)) :
            StringFormat(commonText?.templateFinancialInformationProvidedForFullYear || '{0}', FormatDate(d, formatString));
    } else {
        return StringFormat(commonText?.templateFinancialInformationProvidedThrough || '{0}', FormatDate(d, formatString));
    }
}

export function GetBasisOfAccountingDescription(requestSummary: PortalCreateSubmissionRequestOptions, commonText?: PortalTextCommon): string {
    if (!!requestSummary.basisOfAccountingPreference) {
        if (requestSummary.basisOfAccountingPreference === 'CashAndAccrual') {
            return commonText?.basisOfAccountingCashAndAccrual || '';
        } else {
            switch (requestSummary.basisOfAccountingPreference) {
                case 'Cash':
                    return commonText?.basisOfAccountingCash || '';
                case 'Accrual':
                    return commonText?.basisOfAccountingAccrual || '';
                default:
                    return commonText?.basisOfAccountingNA || '';
            }
        }
    } else {
        return commonText?.basisOfAccountingNA || '';
    }
}

export function GetTypicalAccountingPkgImportDuration(accountingPkg: string, commonText?: PortalTextCommon): string | undefined {
    let range: string | undefined = undefined;

    switch (accountingPkg) {
        case 'quickbooksdesktop':
            range = StringFormat(commonText?.templateMinutes || '{0}', '2-9');
            break;
        case 'quickbooksonline':
            range = StringFormat(commonText?.templateMinutes || '{0}', '3-5');
            break;
        case 'xero':
            range = StringFormat(commonText?.templateMinutes || '{0}', '2-10');
            break;
        case 'sageintacct':
            range = StringFormat(commonText?.templateMinutes || '{0}', '3-12');
            break;
        case 'netsuite':
            range = StringFormat(commonText?.templateMinutes || '{0}', '5-15');
            break;
        case 'myobbusiness':
            range = StringFormat(commonText?.templateMinutes || '{0}', '5-15');
            break;
        case 'businesscentral':
            range = StringFormat(commonText?.templateMinutes || '{0}', '5-15');
            break;
    }
    return range;
}
